import { Component } from 'react';
import { PropTypes } from 'prop-types';
import qs from 'query-string';
import { apis } from '../api/index.js';
import { message } from 'antd';

class HeatmapLoader extends Component {
  static propTypes = {
    viewportData: PropTypes.object.isRequired,
    setHeatmapData: PropTypes.func.isRequired,
    context: PropTypes.object.isRequired,
    aiReportSelected: PropTypes.object.isRequired,
    dicomIds: PropTypes.array,
    sopInstanceId: PropTypes.string,
    studyInstanceUid: PropTypes.string,
    seriesInstanceUid: PropTypes.string,
    thumbIndex: PropTypes.number,
    heatmap: PropTypes.object,
    history: PropTypes.object,
    imageReady: PropTypes.bool,
    resource: PropTypes.object,
  };

  static defaultProps = {
    imageData: {},
    context: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      reportList: [],
      viewerImgSize: {},
    };
  }

  promises = new Map();

  getReportImgView = (reportList = []) => {
    const selectedData = this.props.aiReportSelected;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const findingIds = selectedData.findingIds || [];
    const heatmap = { objectUid: this.props.sopInstanceId, type: 'ai-report' };
    const promiseKey = `${heatmap.objectUid}-${heatmap.type}`;
    if (findingIds.length > 0 && reportList.length > 0) {
      let viewerImgSize = JSON.parse(
        window.localStorage.getItem('viewerImgSize')
      );
      const { width, height } = viewerImgSize;
      canvas.width = width;
      canvas.height = height;
      let multiple = parseInt(width / 1000);
      multiple = multiple <= 0 ? 1 : multiple;
      ctx.clearRect(0, 0, width, height);
      reportList.forEach((report, ri) => {
        const findings = report.findings || [];
        findings.forEach((item, fi) => {
          if (findingIds.indexOf(item.id) >= 0) {
            const points = item.points;
            ctx.beginPath();
            let [maxX, minY] = [0, height];
            points.forEach((p, index) => {
              maxX = maxX < p.x ? p.x : maxX;
              minY = minY > p.y ? p.y : minY;
              if (index === 0) ctx.moveTo(p.x, p.y);
              else ctx.lineTo(p.x, p.y);
            });

            ctx.strokeStyle = '#F0C960';
            ctx.lineWidth = 8;
            ctx.closePath();
            ctx.stroke();

            const fontSize = 30 * multiple;
            ctx.font = `${fontSize}px Arial`;
            ctx.fillStyle = '#F0C960';
            const text = ri + 1 + '-' + (fi + 1);
            ctx.fillText(text, maxX, minY);
          }
        });
      });

      this.props.setHeatmapData({ ...heatmap, canvas });
    } else {
      heatmap.error = 'unrecognised heatmap format.';
      const canvas = document.createElement('canvas');
      canvas.width = 100;
      canvas.height = 100;
      const imgObject = new Image();
      imgObject.src = '';
      ctx.drawImage(imgObject, 0, 0);
      this.props.setHeatmapData({ ...heatmap, canvas });
    }
    this.promises.set(promiseKey, 1);
  };
  getAIHeatmaps = () => {
    const vpData = this.props.viewportData;
    const type = this.props.context.activeId;
    Object.keys(vpData).forEach(key => {
      const vp = vpData[key];
      vp.sopInstanceUid = this.props.sopInstanceId;

      const promiseKey = `${vp.sopInstanceUid}-${type}`;
      if (vp.sopInstanceUid && !this.promises.has(promiseKey)) {
        const heatmap = { objectUid: this.props.sopInstanceId, type };

        let resource = this.props.resource.aiproductResource || [];
        if (resource.length === 0) return;
        let res = resource;
        let arr = {};
        res.forEach(item => {
          arr[item.name] = item.heatmapPath;
        });
        let data = arr[type];
        if (typeof data === 'string') {
          const parts = data.split("'");
          if (parts.length > 1) data = parts[1];

          const canvas = document.createElement('canvas');
          const imgObj = new Image();
          imgObj.src = 'data:image/jpeg;base64,' + data;
          imgObj.onload = () => {
            canvas.width = imgObj.width;
            canvas.height = imgObj.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(imgObj, 0, 0);
            const imageData = ctx.getImageData(
              0,
              0,
              canvas.width,
              canvas.height
            );
            const pixelData = imageData.data;
            for (let i = 0; i < pixelData.length; i += 4) {
              if (pixelData[i] <= 63) {
                pixelData[i + 3] = pixelData[i] * 2;
                pixelData[i] = 0;
                pixelData[i + 1] = 4 * pixelData[i + 1];
                pixelData[i + 2] = 255;
              } else if (pixelData[i] <= 127) {
                pixelData[i + 3] = pixelData[i] * 2;
                pixelData[i] = 0;
                pixelData[i + 1] = 255;
                pixelData[i + 2] = -4 * pixelData[i + 2] + 2 * 255;
              } else if (pixelData[i] <= 191) {
                pixelData[i + 3] = pixelData[i] * 2;
                pixelData[i] = 4 * pixelData[i] - 2 * 255;
                pixelData[i + 1] = 255;
                pixelData[i + 2] = 0;
              } else if (pixelData[i] <= 255) {
                pixelData[i + 3] = pixelData[i] * 2;
                pixelData[i] = 255;
                pixelData[i + 1] = 4 * (255 - pixelData[i + 1]);
                pixelData[i + 2] = 0;
              }
            }
            ctx.putImageData(imageData, 0, 0);
            this.props.setHeatmapData({ ...heatmap, canvas });
          };
        } else {
          heatmap.error = 'unrecognised heatmap format.';
          const canvas = document.createElement('canvas');
          canvas.width = 100;
          canvas.height = 100;
          const imgObject = new Image();
          imgObject.src = '';
          const ctx = canvas.getContext('2d');
          ctx.drawImage(imgObject, 0, 0);
          this.props.setHeatmapData({ ...heatmap, canvas });
        }

        this.promises.set(promiseKey, 1);
      }
    });
  };
  getHeatmaps = from => {
    const params = qs.parse(window.location.search);
    const objects = params.objects ? JSON.parse(params.objects)[0] : {};
    const vpData = this.props.viewportData;
    const type = this.props.context.activeId;
    Object.keys(vpData).forEach(key => {
      const vp = vpData[key];
      if (from === 'screening') vp.sopInstanceUid = this.props.sopInstanceId;
      else vp.sopInstanceUid = objects.ObjectUid;

      const promiseKey = `${vp.sopInstanceUid}-${type}`;
      if (vp.sopInstanceUid && !this.promises.has(promiseKey)) {
        const heatmap = { objectUid: vp.sopInstanceUid, type };
        this.props.setHeatmapData(heatmap);
        let resource, data, res;
        if (from === 'screening') {
          resource = this.props.heatmap || {};
          data = resource.heatmapPath;
        } else if (from === 'aiproduct') {
          resource = this.props.resource.aiproductResource;
          if (resource.length === 0) return;
          res = resource;
          let arr = {};
          res.forEach(item => (arr[item.name] = item.heatmapPath));
          data = arr[type];
        } else {
          resource = this.props.resource.resource;
          if (!resource) return;
          res = resource.resultAllFinding.resultOneFinding;
          let arr = {};
          if (res.length === 0) return;
          res.forEach(item => (arr[item.name] = item.heatmapPath));
          data = arr[type];
        }
        if (typeof data === 'string') {
          const parts = data.split("'");
          if (parts.length > 1) data = parts[1];

          const canvas = document.createElement('canvas');
          const imgObj = new Image();
          imgObj.src = 'data:image/jpeg;base64,' + data;
          imgObj.onload = () => {
            canvas.width = imgObj.width;
            canvas.height = imgObj.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(imgObj, 0, 0);
            const imageData = ctx.getImageData(
              0,
              0,
              canvas.width,
              canvas.height
            );
            const pixelData = imageData.data;
            for (let i = 0; i < pixelData.length; i += 4) {
              if (pixelData[i] <= 63) {
                pixelData[i + 3] = pixelData[i] * 2;
                pixelData[i] = 0;
                pixelData[i + 1] = 4 * pixelData[i + 1];
                pixelData[i + 2] = 255;
              } else if (pixelData[i] <= 127) {
                pixelData[i + 3] = pixelData[i] * 2;
                pixelData[i] = 0;
                pixelData[i + 1] = 255;
                pixelData[i + 2] = -4 * pixelData[i + 2] + 2 * 255;
              } else if (pixelData[i] <= 191) {
                pixelData[i + 3] = pixelData[i] * 2;
                pixelData[i] = 4 * pixelData[i] - 2 * 255;
                pixelData[i + 1] = 255;
                pixelData[i + 2] = 0;
              } else if (pixelData[i] <= 255) {
                pixelData[i + 3] = pixelData[i] * 2;
                pixelData[i] = 255;
                pixelData[i + 1] = 4 * (255 - pixelData[i + 1]);
                pixelData[i + 2] = 0;
              }
            }
            ctx.putImageData(imageData, 0, 0);
            this.props.setHeatmapData({ ...heatmap, canvas });
          };
        } else if (type === 'lungs_line') {
          const canvas = document.createElement('canvas');

          let flag = true;
          const points = [];
          const keypointLabels = [
            'seventh_cervical_vertebra',
            'left_costophrenic_angle',
            'right_costophrenic_angle',
          ];
          res.forEach(item => {
            if (keypointLabels.indexOf(item.name) >= 0) {
              points.push(item.keypoint);
              if (item.confidence < 0.5) flag = false;
            }
          });

          if (flag) {
            const imageInfo = res[0].heatmapPath;
            const imgObj = new Image();
            imgObj.src = 'data:image/jpeg;base64,' + imageInfo;
            imgObj.onload = () => {
              canvas.width = imgObj.width;
              canvas.height = imgObj.height;
              const ctx = canvas.getContext('2d');
              ctx.beginPath();
              let minX = points[0].x,
                minY = points[0].y,
                maxX = 0,
                maxY = 0;
              points.forEach((item, index) => {
                if (index === 0) ctx.moveTo(item.x, item.y);
                else ctx.lineTo(item.x, item.y);

                if (maxX < item.x) maxX = item.x;
                if (maxY < item.y) maxY = item.y;
                if (minX > item.x) minX = item.x;
                if (minY > item.y) minY = item.y;
              });
              ctx.closePath();
              ctx.stroke();

              const ctx1 = canvas.getContext('2d');
              ctx1.moveTo(minX, minY);
              ctx1.lineTo(minX, maxY);
              ctx1.lineTo(maxX, maxY);
              ctx1.lineTo(maxX, minY);
              ctx1.strokeStyle = '#00ff00';
              ctx1.lineWidth = 10;
              ctx1.closePath();
              ctx1.stroke();
              this.props.setHeatmapData({ ...heatmap, canvas });
            };
          }
        } else {
          heatmap.error = 'unrecognised heatmap format.';
          const canvas = document.createElement('canvas');
          canvas.width = 100;
          canvas.height = 100;
          const imgObject = new Image();
          imgObject.src = '';
          const ctx = canvas.getContext('2d');
          ctx.drawImage(imgObject, 0, 0);
          this.props.setHeatmapData({ ...heatmap, canvas });
        }

        this.promises.set(promiseKey, 1);
      }
    });
  };

  selectAiReport = dicomId => {
    if (dicomId) {
      let reportList = [];
      apis.selectAiReport(dicomId).then(res => {
        if (res.code === '0') {
          reportList = res.data;
          this.setState({ reportList });
          this.getReportImgView(reportList);
        } else {
          message.error(res.message);
          if (res.code === '1009') this.props.history.push('/login');
        }
      });
    }
  };

  componentDidUpdate(prevProps) {
    const { dicomIds, thumbIndex } = this.props;
    const { from, from1 } = qs.parse(window.location.search);
    if (from === 'report') {
      if (
        prevProps.dicomIds !== dicomIds ||
        prevProps.thumbIndex !== thumbIndex
      ) {
        this.selectAiReport(dicomIds[thumbIndex]);
      }
      this.getReportImgView(this.state.reportList);
    } else if (from === 'aiproduct' && from1 !== 'aireview') {
      if (this.props.sopInstanceId === prevProps.sopInstanceId) {
        this.getAIHeatmaps(from);
      }
    } else {
      this.getHeatmaps(from);
    }
  }

  render() {
    return null;
  }

  componentWillUnmount() {
    this.promises.clear();
  }
}

export default HeatmapLoader;
